var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1876 333",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32.317 130.683C10.767 153.5 0 181.529 0 214.8c0 32.95 10.767 60.825 32.317 83.633C53.854 321.242 81.412 332.65 115 332.65c28.829 0 51-7.758 66.529-23.283v18.529h53.696V101.221h-53.696v18.537C166 104.237 143.829 96.475 115 96.475c-33.588 0-61.146 11.4-82.683 34.208Zm43.716 132.109c-12.354-12.671-18.537-28.667-18.537-47.992 0-19.321 6.183-35.479 18.537-48.471 12.354-12.671 27.875-19.008 46.571-19.008 21.542 0 40.388 6.496 56.55 19.479v95.517c-16.162 12.995-35.008 19.487-56.55 19.487-18.696 0-34.217-6.333-46.571-19.012Z",
    style: {
      fill: "url(#a)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.617 101.221v165.85c-14.892 9.821-30.413 14.733-46.571 14.733-18.371 0-31.679-4.596-39.909-13.787-8.245-9.184-12.358-22.963-12.358-41.338V101.221h-56.554v129.733c0 32.317 7.846 57.338 23.529 75.079 15.679 17.746 39.038 26.617 70.092 26.617 12.662 0 25.021-2.067 37.062-6.179 12.038-4.117 21.221-9.817 27.567-17.104v18.529h53.696V101.221h-56.554Z",
    style: {
      fill: "url(#b)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.829 38.017v63.204h-43.717v47.525h43.717v95.516c0 29.146 8.079 50.775 24.233 64.863 16.159 14.1 38.65 21.15 67.48 21.15 15.525 0 28.991-1.425 40.395-4.279v-47.992c-8.241 1.896-17.275 2.846-27.087 2.846-16.154 0-28.358-3.246-36.592-9.742-8.241-6.487-12.358-18.291-12.358-35.4v-86.962h76.037v-47.525H662.9V38.017h-56.071Z",
    style: {
      fill: "url(#c)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.696 130.683c-23.446 22.817-35.163 50.846-35.163 84.117 0 32.95 11.717 60.825 35.163 83.633 23.446 22.809 52.425 34.217 86.962 34.217 34.85 0 64.075-11.408 87.679-34.217 23.6-22.808 35.405-50.683 35.405-83.633 0-33.271-11.805-61.3-35.405-84.117-23.604-22.808-52.829-34.208-87.679-34.208-34.537 0-63.516 11.4-86.962 34.208Zm40.629 131.634c-12.192-12.663-18.3-28.509-18.3-47.517 0-19.321 6.108-35.325 18.3-48 12.192-12.663 27.642-19.008 46.333-19.008 19.009 0 34.688 6.345 47.046 19.008 12.358 12.675 18.533 28.679 18.533 48 0 19.008-6.175 34.854-18.533 47.517-12.358 12.675-28.037 19.008-47.046 19.008-18.691 0-34.141-6.333-46.333-19.008Z",
    style: {
      fill: "url(#d)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.72 106.451v24.233c18.063-17.733 42.292-26.608 72.705-26.608 4.754 0 11.562.321 20.437.95v28.987c-5.075-.633-12.517-.954-22.333-.954-29.463 0-52.746 8.4-69.854 25.188v169.65h-31.842V106.451h30.887ZM1274.03 217.17c0 24.084 8.07 44.2 24.233 60.355 16.158 16.479 36.117 24.708 59.871 24.708 23.766 0 43.725-8.15 59.879-24.471 16.154-16.312 24.237-36.508 24.237-60.592 0-24.387-8.083-44.662-24.237-60.825-16.154-16.154-36.113-24.233-59.879-24.233-23.754 0-43.713 8.079-59.871 24.233-16.163 16.163-24.233 36.438-24.233 60.825m.945-82.208c22.171-22.175 49.896-33.267 83.159-33.267 33.271 0 61.066 11.167 83.4 33.505 22.337 22.333 33.504 49.662 33.504 81.97 0 32.009-11.092 59.246-33.263 81.742-22.5 22.496-50.37 33.738-83.641 33.738-33.263 0-60.988-11.167-83.159-33.505-22.175-22.333-33.266-49.658-33.266-81.975 0-32.308 11.091-59.712 33.266-82.208",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M1545.35 0h31.838v327.896h-31.838z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679.84 202.916h164.42c-3.17-21.217-12.354-38.492-27.562-51.796-15.208-13.308-33.429-19.958-54.65-19.958-21.229 0-39.438 6.65-54.654 19.958-15.2 13.304-24.396 30.579-27.554 51.796m.47-67.954c21.538-22.171 48.788-33.263 81.738-33.263 32.942 0 60.117 11.092 81.496 33.263 21.387 22.183 32.079 49.583 32.079 82.208v12.362H1679.84c2.845 22.175 12.508 39.917 28.987 53.217 16.471 13.308 38.646 19.963 66.529 19.963 30.413 0 58.129-7.134 83.159-21.388v30.888c-23.455 13.629-51.171 20.437-83.159 20.437-39.291 0-70.337-11.004-93.141-33.025-22.813-22.017-34.213-49.5-34.213-82.454 0-32.625 10.763-60.025 32.308-82.208",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1010.9009) rotate(.99 -12.162 -.878)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3aaed8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62dea7",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1010.9009) rotate(.99 -11.963 -.876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3aaed8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62dea7",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1010.9009) rotate(.99 -9.862 -.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3aaed8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62dea7",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1010.9009) rotate(.99 -11.388 -.871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3aaed8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#62dea7",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16b20423a2ff1c5911785725fadbde88.svg";
export { ForwardRef as ReactComponent };